import { InfiniteData, QueryClient } from "@tanstack/react-query";
import { NotificationsResponse } from "../../types";

/**
 * Updates all cached notification infinite queries so the UI reflects "mark all as read"
 * without waiting for a refetch (needed for jotai-tanstack-query consumers on native).
 */
export function updateNotificationsCacheAfterMarkAllRead(
  queryClient: QueryClient,
  userId?: number | string | null,
) {
  const notificationQueries = queryClient.getQueriesData<
    InfiniteData<NotificationsResponse>
  >({
    queryKey: userId != null ? ["notifications", userId] : ["notifications"],
    exact: false,
  });

  notificationQueries.forEach(([queryKey, oldData]) => {
    if (!oldData || !Array.isArray(queryKey)) return;

    const isUnreadOnlyQuery = queryKey[3] === true;
    let didUpdate = false;

    const pages = oldData.pages.map((page, index) => {
      if (isUnreadOnlyQuery) {
        if (page.notifications.length === 0) return page;
        didUpdate = true;
        return {
          ...page,
          notifications: [],
          pagination:
            index === 0
              ? { ...page.pagination, total: 0 }
              : page.pagination,
        };
      }

      let pageChanged = false;
      const nextNotifications = page.notifications.map((n) => {
        if (n.is_read) return n;
        pageChanged = true;
        return {
          ...n,
          is_read: true,
          read_at: new Date().toISOString(),
        };
      });

      if (!pageChanged) return page;
      didUpdate = true;
      return { ...page, notifications: nextNotifications };
    });

    if (!didUpdate) return;

    queryClient.setQueryData(queryKey, {
      ...oldData,
      pages,
    });
  });
}
